import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageShell from "../components/sections/PageShell";
import { PageHero, Card } from "../components/landing/Blocks";
import { CASE_STUDIES, caseStudiesIndex as idx } from "../data/caseStudies";
import { applySeo } from "../lib/seo";

export default function CaseStudiesPage() {
  useEffect(() => applySeo(idx), []);
  return (
    <PageShell testId="case-studies-page">
      <PageHero eyebrow="Proof · Before & After" h1={idx.h1} lede={idx.lede} badges={[]} testId="case-studies-hero" />
      <section className="max-w-6xl mx-auto px-5 md:px-8 pb-20 grid gap-6 md:grid-cols-2" data-testid="case-studies-list">
        {CASE_STUDIES.map((c) => (
          <Link key={c.slug} to={c.path} className="group block" data-testid={`case-card-${c.slug}`}>
            <Card className="h-full transition-colors group-hover:border-[var(--ggm-signal-cyan)]">
              <div className="ggm-eyebrow mb-3">Healthcare · Gallatin, TN</div>
              <h2 className="font-condensed uppercase text-white text-2xl leading-tight">Family Health Care of Gallatin</h2>
              <p className="mt-3 font-body text-white/75 leading-relaxed">{c.card}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {c.stats.map(([v, l]) => (
                  <span key={l} className="ggm-hand text-sm mr-3">
                    {v} {l}
                  </span>
                ))}
              </div>
              <span className="mt-6 inline-flex items-center gap-2 font-condensed uppercase tracking-widest text-sm text-[var(--ggm-signal-cyan)]">
                Read the case study <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </span>
            </Card>
          </Link>
        ))}
      </section>
    </PageShell>
  );
}
